import { render, staticRenderFns } from "./treeTransfer.vue?vue&type=template&id=fb0f9404&scoped=true&"
import script from "./treeTransfer.vue?vue&type=script&lang=js&"
export * from "./treeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./treeTransfer.vue?vue&type=style&index=0&id=fb0f9404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f9404",
  null
  
)

export default component.exports